
































































































import PartnerDetail from '@/components/partner/PartnerDetail.vue';
import {Vue, Component} from 'vue-property-decorator';
@Component({
  components: {PartnerDetail}
})
export default class PartnerCopy extends Vue {
  private partnerNo: string = '';
  private showInfo: any = null;

  private async created() {
    this.partnerNo = this.$route.query.partnerNo as string;
    const request: any = {
      pathParams: {
        partnerNo: this.partnerNo
      }
    };
    const {data} = await this.$api.getPartnersActivePartnerNo(request);
    this.showInfo = {
      partnerNo: data.partner.partnerNo,
      partnerName: data.partner.partnerName,
      companyName: data.partner.companyName,
      businessRegistrationNo: data.partner.business.registrationNo,
      sellerTaxationType: data.partner.sellerTaxationType,
      sellerTaxationTypeLabel: this.$t(`PARTNER_SELLER_TAXATION_TYPE_${data.partner.sellerTaxationType}`),
      representativeName: data.partner.representative.name,
      businessType: data.partner.business.type,
      businessCondition: data.partner.business.condition,
      representPhoneNo: data.partner.representative.phoneNo,
      faxNo: data.partner.faxNo,
      representEmail: data.partner.representative.email,
      onlineMarketingBusinessDeclarationNo: data.partner.business.onlineMarketingDeclarationNo,
      dependencyYn: data.partner.dependencyYn,
    };
  }
}
